<template>
    <div class="app">
        <Header label="My Profile" currentpath="profile"></Header>
        <section class="all-v">
            <w-profile class="w-100" :auth="Auth" :logger="logger" :user="user" :floating-button="true" @updated="updated" :changed.sync="changed"></w-profile>
            <w-version/>
        </section>
    </div>
</template>

<script>
import { Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import Header from './Header'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Profile',
    data () {
        return {
            Auth,
            logger: new Logger('Profile'),
            changed: false
        }
    },
    methods: {
        ...mapActions({
            fetchUser: 'auth/fetchUser'
        }),
        updated () {
            this.fetchUser()
            this.changed = false
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    components: {
        Header
    },
    beforeRouteUpdate (to, from, next) {
        if (!this.changed) next()
        else if (confirm('Your changes will be lost. Do you want to continue?')) next()
    },
    beforeRouteLeave (to, from, next) {
        if (!this.changed) next()
        else if (confirm('Your changes will be lost. Do you want to continue?')) next()
    }
}
</script>

<style scoped>
    .app {
        height: 100%;
        padding-top: 85px;
    }

    .all-v {
        height: calc(100% - 85px);
        padding-left: 25%;
        padding-right: 25%;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .all-v::-webkit-scrollbar {
        width: 5px;
        opacity: 0;
    }

    .all-v::-webkit-scrollbar-thumb {
        -webkit-border-radius: 10px;
        border-radius: 10px;
        opacity: 0.5;
        background: #CCC;
    }

    @media (max-width: 768px) {
        .all-v {
            width: 100%;
            padding-left: 17px;
            padding-right: 17px;
            overflow-x: unset;
            overflow-y: unset;
        }
    }
</style>
